import { render, staticRenderFns } from "./DeleteCommandeForm.vue?vue&type=template&id=563f2c70"
import script from "./DeleteCommandeForm.vue?vue&type=script&lang=js"
export * from "./DeleteCommandeForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports